/* index.js */

"use strict";
module.exports = {
    views: {
        WizardExecutionView: require("./src/app/views/wizardexecutionview/WizardExecutionViewComponent"),
    },
    registrations: require("./src/app/Registrations"),
};
